export type Frecuencia = 'mensual' | 'bimestral' | 'trimestral' | 'semestral' | 'anual' | 'unico'

const INTERVALO_MESES: Record<Frecuencia, number> = {
  mensual: 1,
  bimestral: 2,
  trimestral: 3,
  semestral: 6,
  anual: 12,
  unico: 0,
}

/**
 * Determina si un servicio con determinada frecuencia y mes de inicio
 * corresponde facturarse en el mes del período dado.
 *
 * Ejemplo: frecuencia=trimestral, mesInicio=1 (Enero)
 * → Corresponde en meses 1, 4, 7, 10 (cada 3 meses desde Enero)
 *
 * Para mensual siempre retorna true.
 * Para unico siempre retorna false (no genera movimientos recurrentes).
 */
export function leCorrespondeEstePeriodo(
  frecuencia: string,
  mesInicio: number,
  mesPeriodo: number
): boolean {
  const freq = frecuencia as Frecuencia
  const intervalo = INTERVALO_MESES[freq]

  if (intervalo === undefined) return false
  if (intervalo === 0) return false // unico
  if (intervalo === 1) return true // mensual

  // Calcular si mesPeriodo cae en el ciclo
  // (mesPeriodo - mesInicio) mod intervalo === 0
  const diff = ((mesPeriodo - mesInicio) % intervalo + intervalo) % intervalo
  return diff === 0
}

const MESES: Record<string, number> = {
  enero: 1,
  febrero: 2,
  marzo: 3,
  abril: 4,
  mayo: 5,
  junio: 6,
  julio: 7,
  agosto: 8,
  septiembre: 9,
  octubre: 10,
  noviembre: 11,
  diciembre: 12,
}

/**
 * Extrae el número de mes de un string "Mes Año" (ej: "Febrero 2026" → 2)
 */
export function getMesFromPeriodo(mesAnio: string): number {
  const partes = mesAnio.trim().toLowerCase().split(/\s+/)
  if (partes.length < 1) return 0
  return MESES[partes[0]] ?? 0
}

export const NOMBRES_MESES = [
  'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
  'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',
] as const
